import styled from 'styled-components'

const Heading = styled.strong`
  padding-top: 15px;
`

const Paragraph = styled.p`
  margin-top: 10px;
`

const List = styled.ul`
  list-style: disc;
  padding-left: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
`

const ListItem = styled.li`
  margin-top: 5px;
`

export { Heading, Paragraph, List, ListItem }
